/* tslint:disable */
/* eslint-disable */
/**
 * Internal Datadoc API
 * Service to maintain and expose metadata for data in Statistics Norway. Includes the following concepts:  - Data File: A logically defined blob of data from a file system or object storage. - Dataset: A collection of related Data Files which together represent a coherent dataset. These are typically partitioned by time periods. - Data Product: A collection of related Data Files that are produced and maintained by a Dapla team. All data which does not directly contribute to publication of a statistic on ssb.no is defined as a Data Product. - Statistic Product: A collection of related Data Files that are produced and maintained by a Dapla team, and directly contribute to publication of a statistic on ssb.no. The list of all statistic products is defined by the Statistic Register. 
 *
 * The version of the OpenAPI document: 0.1
 * Contact: metadata@ssb.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Describes the confidentiality level implied by where a dataset is stored in the Dapla folder structure.
 * @export
 */
export const Assessment = {
    SENSITIVE: 'SENSITIVE',
    PROTECTED: 'PROTECTED',
    OPEN: 'OPEN'
} as const;
export type Assessment = typeof Assessment[keyof typeof Assessment];


export function instanceOfAssessment(value: any): boolean {
    for (const key in Assessment) {
        if (Object.prototype.hasOwnProperty.call(Assessment, key)) {
            if (Assessment[key as keyof typeof Assessment] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssessmentFromJSON(json: any): Assessment {
    return AssessmentFromJSONTyped(json, false);
}

export function AssessmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Assessment {
    return json as Assessment;
}

export function AssessmentToJSON(value?: Assessment | null): any {
    return value as any;
}

export function AssessmentToJSONTyped(value: any, ignoreDiscriminator: boolean): Assessment {
    return value as Assessment;
}

